import { z } from "zod";
import { CATEGORY_NAME, DESCRIPTION } from "./consts";

export const schema = z.object({
  [CATEGORY_NAME]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddCategoryFormValues = z.infer<typeof schema>;
